module.exports = __webpack_public_path__ + "static/covid19_card_img2@2x-06d69ea5336552e4b1727dc005119031.jpg";